import { GoogleMap, InfoWindowF, LoadScript, Marker } from "@react-google-maps/api";
import { AutoComplete, Button, message, Modal, Select, Switch, Tooltip } from 'antd';
import { FC, ReactElement, ReactNode, useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EditInfos, Infos } from '../components/editinfos';
import { LayoutSite } from '../components/layout';
import { Loader } from '../components/loader';
import { useKeys } from '../keys';
import { add_yards, create_track, create_venue, csvtokml, delete_track, edit_venue, get_sources_list, get_track_content, get_track_list, get_venue_list, remove_venue, set_trackinfos, update_track } from '../services/api.service';
import { APIAnswer, APIAnswerData, JumpInfos, JUMPS, Track, TrackInfos, TrackPoint, Venue } from '../types';
import './tracks.scss';
import { isAdmin } from "../services/auth.header";

const API_KEY = 'AIzaSyAYJ0T0QfMpPex9whIoratlZIIiEaJXAq8';

const MAP_CENTER = { lat: 43.628908, lng: 3.909600 };
const MAP_STYLE = { width: "100%", height: "100%" };
const MAP_ZOOM = 16;

const MAP_OPTIONS = {
    streetViewControl: false,
    mapTypeId: 'satellite',
    scaleControl: true,
    fullscreenControl: true,
    fullscreenControlOptions: { position: 6.0},
    gestureHandling: "greedy",
    disableDoubleClickZoom: true,
    minZoom: 3,
    maxZoom: 20,
    mapTypeControl: false,
    zoomControl: true,
    clickableIcons: false,
    disableDefaultUI: true
};
/* -------------------------------------------------------------------------------- *\
|                               TracksPage
\* -------------------------------------------------------------------------------- */
export const TracksPage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [askedsource, setAskedSource] = useState<string>("");
    const [askedvenue, setAskedVenue] = useState<string>("");
    const [askedtrack, setAskedTrack] = useState<string>("");

    const [map, setMap] = useState<google.maps.Map | null>(null);
    const [mapkey, setmapkey] = useState<string>('map_0');

    const [venues, setVenues] = useState<Venue[]>([]);
    const [sources, setSources] = useState<string[]>([]);
    const [tracks, setTracks] = useState<Track[]>([]);
    const [selectedvenue, setSelectedVenue] = useState<Venue | null>(null);
    const [selectedtrack, setSelectedTrack] = useState<Track | null>(null);
    const [dlgcreatevenuevisible, setDlgcreatevenuevisible] = useState(false);
    const [dlgeditvenuevisible, setDlgeditvenuevisible] = useState(false);
    const [editedvenue, setEditedVenue] = useState<Venue | null>(null);

    const [dlgaddtrackvisible, setDlgaddtrackvisible] = useState(false);
    const [editedtrack, setEditedTrack] = useState<Track>(new Track());

    const [dlgtrackinfosvisible, setDlgTrackInfosVisible] = useState(false);
    const [trackinfosmode, setTrackInfosMode] = useState<'distance' | 'type'>('distance');
    const [trackinfosdistance, setTrackInfosDistance] = useState<number>(0);
    const [trackinfostype, setTrackInfosType] = useState<string>('');
    const [uploadfile, setUploadFile] = useState<string>("");
    const [showfile, setShowFile] = useState(true);
    const [showinfos, setShowInfos] = useState(true);

    const [mappoints, setMapPoints] = useState<TrackPoint[]>([]);
    const [jumpsinfos, setJumpsInfos] = useState<JumpInfos[]>([]);
    const [markers_int, setMarkers_int] = useState<ReactElement[]>([]);
    const [markers_mid, setMarkers_mid] = useState<ReactElement[]>([]);
    const [markers_ext, setMarkers_ext] = useState<ReactElement[]>([]);
    const [maplines, setMapLines] = useState<google.maps.Polyline[]>([]);
    const [trackinfos, setTrackInfos] = useState<TrackInfos | null>(null);
    
    const [mappc, setMapPC] = useState<TrackPoint[]>([]);
    const [selectedpc, setSelectedPC] = useState<TrackPoint>();
    const [markers_selpc, setMarkersSelectedPC] = useState<ReactElement[]>([]);

    const [showgate, setShowGate] = useState(false);
    const [showobstacle, setShowObstacle] = useState(false);
    const [showyards, setShowYards] = useState(false);
    const [showmids, setShowMids] = useState(false);
    const [follow, setFollow] = useState(true);

    const racetypes: { value: string, label: string }[] =
    [
        { value: "ATTELÉ", label: "ATTELÉ" },
        { value: "CROSS", label: "CROSS" },
        { value: "HAIES", label: "HAIES" },
        { value: "MONTÉ", label: "MONTÉ" },
        { value: "PLAT", label: "PLAT" },
        { value: "STEEPLE", label: "STEEPLE" }
    ];

    const isadmin = isAdmin();

    const scrollToItem = (id: string) =>
    {
        const element = document.getElementById(id);
        if (element)
        {
            element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    };
    const onKeyDown = (event) => 
    {
        if (selectedpc)
        {
            var i = mappc.indexOf(selectedpc);
            if (event.key === 'ArrowUp')
            {
                if (i > 0)
                {
                    scrollToItem('mappc_' + (i - 1));
                    setSelectedPC(mappc[i - 1]);
                }
            }
            else if (event.key === 'ArrowDown')
            {
                if (i < mappc.length - 1)
                {
                    scrollToItem('mappc_' + (i + 1));
                    setSelectedPC(mappc[i + 1]);
                }
            }
            event.preventDefault();
        }
    }
    const onKeyUp = () => {};

    useKeys(onKeyDown, onKeyUp, ['ArrowDown', 'ArrowUp']);

    /* -------------------------------------------------------------------------------- *\
    |                               managerapianswer
    \* -------------------------------------------------------------------------------- */
    const managerapianswer = (answer: APIAnswer, msgok: string, msgko: string) =>
    {
        if (answer.status)
        {
            message.info(msgok);
            setEditedVenue(null);
            setLoading(true);
            refreshVenues().then(() => setLoading(false));
        }
        else
        {
            message.error(msgko + answer.message);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               refreshVenues
    \* -------------------------------------------------------------------------------- */
    const refreshVenues = useCallback(async () =>
    {
        get_venue_list().then((m: Venue[]) =>
        {
            setVenues(m);
        })
        .then(() =>
        {
            return get_sources_list();
        })
        .then((m: string[]) =>
        {
            setSources(m);
        })
        .catch(error =>
        {
            message.error(error.message);
            if (error.status === 403 || error.status === 401) navigate('/login');
        });
    }, [navigate]);
    /* -------------------------------------------------------------------------------- *\
    |                               refreshTracks
    \* -------------------------------------------------------------------------------- */
    const refreshTracks = async (sic: string) =>
    {
        setTracks([]);
        get_track_list(sic).then((m: Track[]) =>
        {
            setTracks([...m].sort((a: Track, b: Track) => (a.code ?? "").localeCompare(b.code ?? "", undefined, { numeric: true, sensitivity: 'base' })));
        })
        .catch(error =>
        {
            message.error(error.message);
            if (error.status === 403 || error.status === 401) navigate('/login');
        });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               createvenue
    \* -------------------------------------------------------------------------------- */
    function createvenue()
    {
        setEditedVenue({ name: "", sic: "", source: "", tracks: [] });
        setDlgcreatevenuevisible(true);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               dlgcreatevenueclose
    \* -------------------------------------------------------------------------------- */
    function dlgcreatevenueclose(save: boolean)
    {
        if (save && editedvenue)
        {
            if (!editedvenue.sic)
            {
                message.error("You must give a SIC code to create a venue.");
                return;
            }
            if (!editedvenue.source)
            {
                message.error("You must select a source to create a venue.");
                return;
            }
        }
        setDlgcreatevenuevisible(false);
        if (save && editedvenue)
        {
            create_venue(editedvenue.sic, editedvenue.name, editedvenue.source)
            .then((answer: APIAnswer) => managerapianswer(answer, answer.message ? answer.message : "Venue created", "An error occured while creating: "))
            .catch((error) => { message.info(error); })
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               removevenue
    \* -------------------------------------------------------------------------------- */
    function removevenue(sic: string)
    {
        if (selectedvenue && window.confirm("Do you really want to remove the venue " + selectedvenue.name + "?"))
        {
            remove_venue(sic)
            .then((answer: APIAnswer) => managerapianswer(answer, "Venue removed", "An error occured while removing: "))
            .then(() => { changesearchparams(askedsource, null, null); })
            .catch((error) => { message.info(error); })
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               editvenue
    \* -------------------------------------------------------------------------------- */
    function editvenue(venue: Venue)
    {
        if (venue)
        {
            const v: Venue = Object.assign(new Venue(), venue);
            setEditedVenue(v);
            setDlgeditvenuevisible(true);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               dlgeditvenueclose
    \* -------------------------------------------------------------------------------- */
    function dlgeditvenueclose(save: boolean)
    {
        if (save && editedvenue)
        {
            if (!editedvenue.sic)
            {
                message.error("You must give a SIC code to create a venue.");
                return;
            }
            if (!editedvenue.source)
            {
                message.error("You must select a source to create a venue.");
                return;
            }
        }
        setDlgeditvenuevisible(false);
        if (save && editedvenue)
        {
            edit_venue(editedvenue.sic, editedvenue.name, editedvenue.source)
            .then((answer: APIAnswer) => managerapianswer(answer, "Venue modified", "An error occured while modifiying: "))
            .then(() => setLoading(true))
            .then(() => get_venue_list())
            .then((m: Venue[]) =>
            {
                setVenues(m);
                setLoading(false);
                const f = m.find((v: Venue) => v.sic === editedvenue.sic);
                if (f)
                {
                    changesearchparams(askedsource, f, null);
                }
                setEditedVenue(null);
            })
            .catch(error =>
            {
                message.error(error.message);
                setEditedVenue(null);
                if (error.status === 403 || error.status === 401) navigate('/login');
            });
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               importvenues
    \* -------------------------------------------------------------------------------- */
    function importvenues()
    {
        window.location.href = "/importvenues";
    }
    /* -------------------------------------------------------------------------------- *\
    |                               importtracks
    \* -------------------------------------------------------------------------------- */
    function importtracks()
    {
        window.location.href = "/importtracks";
    }
    /* -------------------------------------------------------------------------------- *\
    |                               addtrack
    \* -------------------------------------------------------------------------------- */
    function addtrack(venue: Venue | null)
    {
        const t = new Track();
        t.sic = venue ? venue.sic : "";
        t.distance = 1000;
        t.type = "PLAT";
        setEditedTrack(t);
        setUploadFile("");
        setDlgaddtrackvisible(true);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               dlgaddtrackclose
    \* -------------------------------------------------------------------------------- */
    function dlgaddtrackclose(save: boolean)
    {
        if (save)
        {
            if (!editedtrack.sic)
            {
                message.error("Venue is required");
                return;
            }
            if (!editedtrack.code)
            {
                message.error("Track code is required");
                return;
            }
            const targetvenue = venues.find((v: Venue) => v.sic === editedtrack.sic);
            if (!targetvenue)
            {
                message.error("Unknown venue " + editedtrack.sic);
                return;
            }
            if (targetvenue.tracks.find((t: Track) => t.code === editedtrack.code))
            {
                message.error("Track " + editedtrack.code + " already exists on " + editedtrack.sic);
                return;
            }
            if (!uploadfile)
            {
                message.error("You must choose a file to upload");
                return;
            }
            if (uploadfile.length === 0)
            {
                message.error("You must choose a file to upload");
                return;
            }
            setLoading(true);
            create_track(editedtrack.sic, editedtrack.code, editedtrack.distance, editedtrack.type, uploadfile)
            .then((answer: APIAnswer) => managerapianswer(answer, "Track created", "An error occured while creating track: "))
            .then(() => refreshTracks(editedtrack.sic))
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            })
            .finally(() => setLoading(false));
        }
        setDlgaddtrackvisible(false);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               handleuploadfile
    \* -------------------------------------------------------------------------------- */
    function handleuploadfile(files: FileList)
    {
        if (files && files[0])
        {
            const f: File = files[0];

            var reader = new FileReader();
            reader.addEventListener('load', (e) =>
            {
                if (e.loaded === e.total)
                {
                    var errors: string[] = [];
                    var warns: string[] = [];
                 
                    const els: string[] = f.name.split('_');
                    let newtrack: Track | null = null;
                    if (els.length >= 4)
                    {
                        const t = new Track();
                        t.sic = els[0];
                        t.code = els[1];
                        t.type = els[2];
                        t.distance = parseInt(els[3]);

                        if (!venues.find((v: Venue) => v.sic === t.sic))
                        {
                            warns.push("Unknown venue " + t.sic);
                            t.sic = editedtrack.sic;
                        }
                        newtrack = t;
                    }
                    const content: string = e.target ? e.target.result as string : "";
                    const lines: string[] = content.replace(/\r/g, '').split('\n');
                    var first: boolean = true;
                    for(const line of lines)
                    {
                        const els: string[] = line.split(';');
                        if (first)
                        {
                            if (els.length !== 8)
                            {
                                errors.push("Line " + (lines.indexOf(line) + 1) + " must have 8 elements");
                            }
                            if (!els[0].toLocaleUpperCase().startsWith("DIST"))
                            {
                                errors.push("Line " + (lines.indexOf(line) + 1) + " must start with DIST");
                            }
                            if (errors.length > 0) break;
                            first = false;
                        }
                        if (els.length > 1 && els.length !== 8)
                        {
                            errors.push("Line " + (lines.indexOf(line) + 1) + " must have 8 elements");
                        }
                        if (errors.length > 5)
                        {
                            errors.push("Too many errors");
                            break;
                        }
                    }

                    if (errors.length > 0)
                    {
                        setUploadFile("");
                        for(const error of errors)
                        {
                            message.error(error);
                        }
                        for(const warn of warns)
                        {
                            message.warning(warn);
                        }
                        setShowFile(false);
                        setTimeout(() => setShowFile(true), 100);
                    }
                    else
                    {
                        setUploadFile(e.target ? e.target.result as string : "");

                        for(const warn of warns)
                        {
                            message.warning(warn);
                        }
                        if (newtrack)
                        {
                            setEditedTrack(newtrack);
                        }
                        
                        setShowInfos(false);
                        setTimeout(() => setShowInfos(true), 100);
                    }
                }
            });
            reader.readAsText(f as Blob);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               changeselectedvenue
    \* -------------------------------------------------------------------------------- */
    function changeselectedvenue(venue: Venue | null)
    {
        setSelectedVenue(venue);
        changeselectedtrack(null);
        if (venue)
        {
            refreshTracks(venue.sic);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               changeselectedjump
    \* -------------------------------------------------------------------------------- */
    function changeselectedjump(jump: JumpInfos)
    {
        const t: string = "PCO" + String(jump.number).padStart(2, '0') + jump.key + String(jump.distance);
        setSelectedPC(mappc.find((p: TrackPoint) => p.extra === t));
    }
    /* -------------------------------------------------------------------------------- *\
    |                               changeselectedtrack
    \* -------------------------------------------------------------------------------- */
    function changeselectedtrack(track: Track | null)
    {
        if (track === selectedtrack) return;

        setMarkers_int([]);
        setMarkers_mid([]);
        setMarkers_ext([]);
        setMapPC([]);
        setMarkersSelectedPC([]);
        setJumpsInfos([]);

        for(const pl of maplines)
        {
            pl.setMap(null);
        }
        setMapLines([]);
        setSelectedTrack(track);
        if (track)
        {
            get_track_content(track.sic, track.code).then((content: string) =>
            {
                var points: TrackPoint []= [];
                var infos: TrackInfos = new TrackInfos();
                var jumps: JumpInfos[] = [];

                infos.dist_official = track.distance;

                const lines = content.replace(/\r/g, '').split("\n");
                var first: boolean = true;
                for (const line of lines)
                {
                    if (!first && line)
                    {
                        const els = line.split(";");
                        if (els.length >= 8)
                        {
                            const pt: TrackPoint = new TrackPoint();
                            pt.distance = parseFloat(els[0]);
                            pt.lat_int = parseFloat(els[1]);
                            pt.lon_int = parseFloat(els[2]);
                            pt.lat_mid = parseFloat(els[3]);
                            pt.lon_mid = parseFloat(els[4]);
                            pt.lat_ext = parseFloat(els[5]);
                            pt.lon_ext = parseFloat(els[6]);
                            pt.extra = els[7].trim();
                            if (pt.extra === '0') pt.extra = '';
                            
                            points.push(pt);
                            
                            if (pt.extra === 'PCDEP') infos.dist_pcdep = pt.distance;
                            infos.dist_total = pt.distance;

                            if (pt.extra.startsWith('PY'))
                            {
                                infos.withyards = true;
                            }
                            
                            if (pt.extra.startsWith('PCO'))
                            {
                                infos.jumps.push(pt);

                                const no: number = parseInt(pt.extra.substring(3, 5));
                                const key: string = pt.extra.substring(5, 9);
                                const dist: number = parseInt(pt.extra.substring(9));
                                
                                var jump: JumpInfos = new JumpInfos();
                                jump.distance = dist;
                                jump.key = key;
                                jump.number = no;
                                jump.position = pt;

                                const fj = JUMPS.find(j => j.key === key);
                                if (fj)
                                {
                                    jump.text = fj.text;
                                }

                                jumps.push(jump);
                            }
                        }
                    }
                    first = false;
                }
                if (points.length > 0)
                {
                    const center_lat = points.reduce((sum, p) => sum + p.lat_int, 0) / points.length;
                    const center_lon = points.reduce((sum, p) => sum + p.lon_int, 0) / points.length;

                    setCenter({ lat: center_lat, lng: center_lon });
                }
                setMapPoints(points);
                setMapPC(points.filter(n => n.extra).reverse());
                setTrackInfos(infos);
                setJumpsInfos(jumps.reverse());
            })
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            });
        }
        else
        {
            setTrackInfos(null);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               deletetrack
    \* -------------------------------------------------------------------------------- */
    function deletetrack(track: Track | null)
    {
        if (track)
        {
            if (window.confirm("Do you really want to remove the track " + track.code + " from " + track.sic + "?"))
            {
                setLoading(true);
                delete_track(track.sic, track.code)
                .then((answer: APIAnswer) => managerapianswer(answer, "Track deleted", "An error occured while creating track: "))
                .then(() => { setSelectedTrack(null); refreshTracks(track.sic) })
                .catch(error =>
                {
                    message.error(error.message);
                    if (error.status === 403 || error.status === 401) navigate('/login');
                })
                .finally(() => setLoading(false));
            }
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               edittrackinfos
    \* -------------------------------------------------------------------------------- */
    function edittrackinfos(track: Track | null, mode: 'distance' | 'type')
    {
        if (track)
        {
            setTrackInfosMode(mode);
            setTrackInfosDistance(track.distance);
            setTrackInfosType(track.type);
            setDlgTrackInfosVisible(true);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               dlgtrackinfosclose
    \* -------------------------------------------------------------------------------- */
    async function dlgtrackinfosclose(save: boolean)
    {
        if (save && selectedtrack)
        {
            if (!trackinfostype)
            {
                message.error("Type is required");
                return;
            }
            if (!trackinfosdistance || trackinfosdistance <= 0)
            {
                message.error("Distance is invalid");
                return;
            }
        }
        setDlgTrackInfosVisible(false);
        if (save && selectedtrack)
        {
            try
            {
                setLoading(true);
                const answer: APIAnswer = await set_trackinfos(selectedtrack.sic, selectedtrack.code, trackinfostype, trackinfosdistance);
                if (answer.status)
                {
                    window.location.reload();
                }
                else
                {
                    message.error(answer.message);
                }
            }
            catch (error: any)
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            }
            finally
            {
                setLoading(false);
            }
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               getcsv
    \* -------------------------------------------------------------------------------- */
    async function getcsv(track: Track | null)
    {
        try
        {
            if (track)
            {
                let content: string = await get_track_content(track.sic, track.code);
                const url = window.URL.createObjectURL(new Blob([content]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${track.sic}_${track.code}_${track.type}_${track.distance}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        catch (error: any)
        {
            message.error(error.message);
            if (error.status === 403 || error.status === 401) navigate('/login');
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               getkml
    \* -------------------------------------------------------------------------------- */
    async function getkml(track: Track | null)
    {
        try
        {
            if (track)
            {
                let content: string = await get_track_content(track.sic, track.code);
                let answer: APIAnswerData = await csvtokml(content)

                if (answer.status)
                {
                    const url = window.URL.createObjectURL(new Blob([answer.data.kml]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${track.sic}_${track.code}_${track.type}_${track.distance}.kml`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }
                else
                {
                    message.error(answer.message);
                }
            }
        }
        catch (error: any)
        {
            message.error(error.message);
            if (error.status === 403 || error.status === 401) navigate('/login');
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               removeyards
    \* -------------------------------------------------------------------------------- */
    async function removeyards(track: Track | null)
    {
        try
        {
            if (track)
            {
                setLoading(true);
                const content: string = await get_track_content(track.sic, track.code);
                const lines = content.split('\n');
                const filtered = lines.filter(line =>
                {
                    const els = line.split(';');
                    return els.length < 8 || !els[7].trim().startsWith('PY');
                });
                const newcontent = filtered.join('\n');
                const answer: APIAnswer = await update_track(track.sic, track.code, newcontent);
                if (answer.status)
                {
                    window.location.reload();
                }
                else
                {
                    message.error(answer.message);
                }
            }
        }
        catch (error: any)
        {
            message.error(error.message);
            if (error.status === 403 || error.status === 401) navigate('/login');
        }
        finally
        {
            setLoading(false);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               addyards
    \* -------------------------------------------------------------------------------- */
    async function addyards(track: Track | null)
    {
        try
        {
            if (track)
            {
                setLoading(true);
                const answer: APIAnswer = await add_yards(track.sic, track.code);
                if (answer.status)
                {
                    window.location.reload();
                }
                else
                {
                    message.error(answer.message);
                }
            }
        }
        catch (error: any)
        {
            message.error(error.message);
            if (error.status === 403 || error.status === 401) navigate('/login');
        }
        finally
        {
            setLoading(false);
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               changesearchparams
    \* -------------------------------------------------------------------------------- */
    function changesearchparams(source: string, venue: Venue | null, track: Track | null)
    {
        let sic: string = "";
        let code: string = "";
        if (venue)
        {
            if (track)
            {
                sic = venue.sic;
                code = track.code;
            }
            else
            {
                sic = venue.sic;
            }
        }

        if (sic !== askedvenue || code !== askedtrack || source !== askedsource)
        {
            let params = {};

            if (source)
            {
                params = { ...params, source: source };
            }
            if (sic && code)
            {
                params = { ...params, venue: sic, code: code };
            }
            else if (sic)
            {
                params = { ...params, venue: sic };
            }
            setSearchParams(params);
            setmapkey(mapkey.split('_')[0] + '_' + (parseInt(mapkey.split('_')[1]) + 1));
        }
    }
    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() =>
    {
        /* -------------------------------------------------------------------------------- *\
        |                               addpolyline
        \* -------------------------------------------------------------------------------- */
        function addpolyline(path: google.maps.LatLngLiteral[], color: string) : google.maps.Polyline
        {
            const polyline = new google.maps.Polyline({
                path: path,
                geodesic: true,
                strokeColor: color,
                strokeOpacity: 1.0,
                strokeWeight: 1
            });
            polyline.setMap(map);
            return polyline;
        }
        if (!map) return;

        setLoading(true);
        var marks_int: ReactElement[] = [];
        var marks_mid: ReactElement[] = [];
        var marks_ext: ReactElement[] = [];
        var lines: google.maps.Polyline[] = [];

        const icon_size = 10;
        const gsize = new window.google.maps.Size(icon_size, icon_size);
        const ganchor = new google.maps.Point(icon_size / 2, icon_size / 2);

        var index: number = 0;
        for(const pt of mappoints)
        {
            const pos_int = { lat: pt.lat_int, lng: pt.lon_int };
            const pos_mid = { lat: pt.lat_mid, lng: pt.lon_mid };
            const pos_ext = { lat: pt.lat_ext, lng: pt.lon_ext };
            if ((pt.extra === 'PCDEP' || pt.extra === 'PCARR') || (Number(pt.extra) !== 0 && !pt.extra.startsWith('PY') && parseInt(pt.extra.slice(2))))
            {
                marks_int.push(
                    <Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/green_dot.png`, scaledSize: gsize, anchor: ganchor}}>
                        <div>{pt.extra}</div>
                        {
                            showgate &&
                            <InfoWindowF position={pos_int}><div style={{color: 'black'}}>{pt.extra}</div></InfoWindowF>
                        }
                    </Marker>
                );
                // lines.push(<Polyline key={`polyline_${index}`} path={[pos_int, pos_ext]} options={{strokeColor:'#pink', strokeOpacity: 1.0, strokeWeight: 1}} />);
                lines.push(addpolyline([ pos_int, pos_ext ], '#pink'));

                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/green_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            else if (pt.extra.startsWith("PCO"))
            {
                marks_int.push(
                    <Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/pink_dot.png`, scaledSize: gsize, anchor: ganchor}}>
                        <div>{pt.extra}</div>
                        {
                            showobstacle &&
                            <InfoWindowF position={pos_int}><div style={{color: 'black'}}>{pt.extra}</div></InfoWindowF>
                        }
                    </Marker>
                );
                // lines.push(<Polyline key={`polyline_${index}`} path={[pos_int, pos_ext]} options={{strokeColor:'#FF00B6', strokeOpacity: 1.0, strokeWeight: 2}} />);
                lines.push(addpolyline([ pos_int, pos_ext ], '#FF00B6'));
                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/pink_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            else if (pt.extra.startsWith("PY"))
            {
                marks_int.push(
                    <Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/yellow_dot.png`, scaledSize: gsize, anchor: ganchor}}>
                        <div>{pt.extra}</div>
                        {
                            showyards &&
                            <InfoWindowF position={pos_int}><div style={{color: 'black'}}>{pt.extra}</div></InfoWindowF>
                        }
                    </Marker>
                );
                // lines.push(<Polyline key={`polyline_${index}`} path={[pos_int, pos_ext]} options={{strokeColor:'#FAFF00', strokeOpacity: 1.0, strokeWeight: 2}} />);
                lines.push(addpolyline([ pos_int, pos_ext ], '#FAFF00'));
                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/yellow_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            else
            {
                marks_int.push(<Marker key={`marker_int_${index}`} position={pos_int} icon={{ url: `/images/blue_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_ext.push(<Marker key={`marker_ext_${index}`} position={pos_ext} icon={{ url: `/images/red_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
                marks_mid.push(<Marker key={`marker_mid_${index}`} position={pos_mid} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            }
            index++;
        }
        setMarkers_int(marks_int);
        setMarkers_mid(marks_mid);
        setMarkers_ext(marks_ext);
        setMapLines(lines);
        setLoading(false);

    // eslint-disable-next-line
    }, [mappoints, showgate, showobstacle, showyards, showmids])
    useEffect(() =>
    {
        if (selectedpc)
        {
            const icon_size = 20;
            const gsize = new window.google.maps.Size(icon_size, icon_size);
            const ganchor = new google.maps.Point(icon_size / 2, icon_size / 2);
            const pos_int = { lat: selectedpc.lat_int, lng: selectedpc.lon_int };
            const pos_ext = { lat: selectedpc.lat_ext, lng: selectedpc.lon_ext };
            var marks: ReactElement[] = [];
            marks.push(<Marker key={`marker_selpc1`} position={pos_int} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);
            marks.push(<Marker key={`marker_selpc2`} position={pos_ext} icon={{ url: `/images/white_dot.png`, scaledSize: gsize, anchor: ganchor }}/>);

            setMarkersSelectedPC(marks);
        }
        else
        {
            setMarkersSelectedPC([]);
        }

    }, [selectedpc])
    useEffect(() =>
    {
        refreshVenues().then(() => setLoading(false));
    }, [refreshVenues])
    useEffect(() =>
    {
        if (follow && selectedpc)
        {
            const pt = { lat: (selectedpc.lat_int + selectedpc.lat_int) / 2, lng: (selectedpc.lon_int + selectedpc.lon_int) / 2 };
            setCenter(pt);
        }
    }, [follow, selectedpc])

    useEffect(() =>
    {
        if (askedvenue)
        {
            const fv = venues.find((v: Venue) => v.sic === askedvenue);
            if (fv)
            {
                changeselectedvenue(fv);
            }
            else
            {
                changeselectedvenue(null);
            }
        }
        else
        {
            changeselectedvenue(null);
        }
    // eslint-disable-next-line
    }, [askedvenue, venues]);
    useEffect(() =>
    {
        if (askedtrack)
        {
            const ft = tracks.find((t: Track) => t.code === askedtrack);
            if (ft)
            {
                changeselectedtrack(ft);
            }
        }
        else
        {
            changeselectedtrack(null);
        }
    // eslint-disable-next-line
    }, [askedtrack, tracks]);
    useEffect(() =>
    {
        if (selectedtrack && map)
        {
            changeselectedtrack(selectedtrack);
        }
    // eslint-disable-next-line
    }, [map]);
    useEffect(() =>
    {
        var param_source: string | null = searchParams.get('source');
        if (param_source)
        {
            if (param_source !== askedsource) setAskedSource(param_source);
        }
        else
        {
            if (askedsource !== "") setAskedSource("");
        }
        var param_venue: string | null = searchParams.get('venue');
        if (param_venue)
        {
            if (param_venue !== askedvenue) setAskedVenue(param_venue);
        }
        else
        {
            if (askedvenue !== "") setAskedVenue("");
        }
        var param_code: string | null = searchParams.get('code');
        if (param_code)
        {
            if (param_code !== askedtrack) setAskedTrack(param_code);
        }
        else
        {
            if (askedtrack !== "") setAskedTrack("");
        }
    // eslint-disable-next-line
    }, [searchParams]);

    const [center, setCenter] = useState(MAP_CENTER);
    const zoom = MAP_ZOOM;
    const options = MAP_OPTIONS;

    const [mapwidth] = useState(MAP_STYLE.width);
    const [mapheight] = useState(MAP_STYLE.height);

    return (
        <LayoutSite>
            <div className="tracks">
                {loading ? <Loader /> : <></>}
                <div className="tracks__header">
                    <div>Venues and tracks</div>
                </div>
                <div className="tracks__body">
                    <div className="tracks__body__title">
                        <Button size='small' onClick={() => { createvenue(); }}>Create venue</Button>
                        <Button size='small' style={{ marginLeft: '20px' }} onClick={() => addtrack(null)}>Add track</Button>
                        {
                            isadmin &&
                            <Button size='small' style={{ marginLeft: '20px' }} onClick={() => importvenues()}>import venues</Button>
                        }
                        {
                            isadmin &&
                            <Button size='small' style={{ marginLeft: '20px' }} onClick={() => importtracks()}>import tracks</Button>
                        }
                    </div>
                    <div className="tracks__body__sources">
                        <div className='tracks__body__sources__label'>sources:</div>
                        <div className={'tracks__body__sources__source' + ("" === askedsource ? ' tracks__body__selected' : '')} onClick={() => { changesearchparams("", null, null); }}>
                            <div className='tracks__body__sources__source__title' >All</div>
                        </div>
                        {
                            sources.map((s: string, index: number) => 
                            {
                                return (
                                    <div className={'tracks__body__sources__source' + (s === askedsource ? ' tracks__body__selected' : '')} key={'source_' + index} onClick={() => { changesearchparams(s, null, null); }}>
                                        <div className='tracks__body__sources__source__title' >{s}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="tracks__body__venues">
                        {
                            venues.filter((v: Venue) => askedsource === '' || v.source === askedsource).map((v: Venue, index: number) => 
                            {
                                return (
                                    <div className={'tracks__body__venues__venue' + (v.sic === selectedvenue?.sic ? ' tracks__body__selected' : '')} key={'source_' + index} onClick={() => { changesearchparams(askedsource, v, null); }}>
                                        <div className='tracks__body__venues__venue__title'>{v.sic + ' (' + v.tracks.length + ')'}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {
                        selectedvenue &&
                        <>
                            <div className="tracks__body__tracks__title">
                                <div>Tracks of {selectedvenue.sic + ' (' + (selectedvenue.name !== selectedvenue.sic ? selectedvenue.name + ', ' : '') + selectedvenue.tracks.length + ' tracks, ' + (selectedvenue.source ? selectedvenue.source : 'no source') + ')'}</div>
                                <Button size='small' onClick={() => editvenue(selectedvenue)}>Edit {selectedvenue.sic}</Button>
                                <Button size='small' onClick={() => removevenue(selectedvenue.sic)}>Remove {selectedvenue.sic}</Button>
                            </div>
                            <div className="tracks__body__tracks">
                            {
                                tracks.map((t: Track) => 
                                {
                                    return (
                                        <div className={'tracks__body__tracks__track' + (t.code === selectedtrack?.code ? ' tracks__body__selected' : '') } key={'track_' + t.code} onClick={() => { changesearchparams(askedsource, selectedvenue, t); }}>
                                            <div className='tracks__body__tracks__track__title' key={t.code}>{t.code}</div>
                                        </div>
                                    )
                                })
                            }
                            </div>
                        </>
                    }
                    <div style={selectedtrack ? {} : { display: 'none' }}>
                        <div className="tracks__body__track">
                            <div className='tracks__body__track__infos'>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>Sic</div>
                                    <div className='tracks__body__track__infos__line__value'>{selectedtrack?.sic}</div>
                                </div>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>Track code</div>
                                    <div className='tracks__body__track__infos__line__value'>{selectedtrack?.code}</div>
                                </div>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>Official distance</div>
                                    <div className='tracks__body__track__infos__line__value'>{trackinfos?.dist_official}</div>
                                </div>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>Track type</div>
                                    <div className='tracks__body__track__infos__line__value'>{selectedtrack?.type}</div>
                                </div>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>PCDEP distance</div>
                                    <div className='tracks__body__track__infos__line__value'>{trackinfos?.dist_pcdep}</div>
                                </div>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>Total distance</div>
                                    <div className='tracks__body__track__infos__line__value'>{trackinfos?.dist_total}</div>
                                </div>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>Yards</div>
                                    <div className='tracks__body__track__infos__line__value'>{trackinfos?.withyards ? 'Yes' : 'No'}</div>
                                </div>
                                <div className='tracks__body__track__infos__line'>
                                    <div className='tracks__body__track__infos__line__label'>Jumps</div>
                                    <div className='tracks__body__track__infos__line__value'>{trackinfos?.jumps.length}</div>
                                </div>
                                <div className='tracks__body__track__infos__button'>
                                    <Button size="small" onClick={() => edittrackinfos(selectedtrack, 'distance')}>Edit distance</Button>
                                    <Button size="small" onClick={() => edittrackinfos(selectedtrack, 'type')}>Edit type</Button>
                                </div>
                                <div className='tracks__body__track__infos__button'>
                                    <Button size="small" onClick={() => getcsv(selectedtrack)}>Get csv</Button>
                                    <Button size="small" onClick={() => getkml(selectedtrack)}>Get kml</Button>
                                </div>
                                <div className='tracks__body__track__infos__button'>
                                    { !trackinfos?.withyards && <Button size="small" onClick={() => addyards(selectedtrack)}>Add yards</Button> }
                                    { trackinfos?.withyards && <Button size="small" onClick={() => removeyards(selectedtrack)}>Remove yards</Button> }
                                </div>
                                <div className='tracks__body__track__infos__button'>
                                    <Button size="small" onClick={() => deletetrack(selectedtrack)}>Delete track</Button>
                                </div>
                            </div>
                            <div className='tracks__body__track__pcs'>
                            {
                                mappc.map((pc,i) => 
                                {
                                    return (
                                        <div key={'pc_' + i} id={'mappc_' + i}>
                                            <Tooltip title={pc.distance + "m"} placement="right">
                                                <div className={'tracks__body__track__pcs__line' + (pc === selectedpc ? ' tracks__body__track__pcs__line__active' : '')} onClick={n => { setSelectedPC(pc); }}>
                                                    {pc.extra}
                                                </div>
                                            </Tooltip>
                                        </div>
                                    )
                                })
                            }
                            </div>
                            <div className='tracks__body__track__map'>
                                <div className="tracks__body__track__map__tools">
                                    <Switch size="small" onChange={(e) => {setShowGate(!showgate);}} checked={showgate}/>
                                    <div>Afficher les gates</div>
                                    <Switch size="small" onChange={(e) => {setShowObstacle(!showobstacle);}} checked={showobstacle}/>
                                    <div>Afficher les obstacles</div>
                                    <Switch size="small" onChange={(e) => {setShowYards(!showyards);}} checked={showyards}/>
                                    <div>Afficher les yards</div>
                                    <Switch size="small" onChange={(e) => {setShowMids(!showmids);}} checked={showmids}/>
                                    <div>Afficher la ligne 1m</div>
                                    <Switch size="small" onChange={(e) => {setFollow(!follow);}} checked={follow}/>
                                    <div>follow</div>
                                </div>
                                <LoadScript googleMapsApiKey={API_KEY} >
                                    <GoogleMap
                                        key={mapkey}
                                        id='themap'
                                        onLoad={(map) => setMap(map)}
                                        mapContainerStyle={{ width: mapwidth, height: mapheight }}
                                        zoom={zoom}
                                        center={center}
                                        options={options}>
                                        { markers_int }
                                        { showmids ? markers_mid : <></> }
                                        { markers_ext }
                                        { markers_selpc }
                                    </GoogleMap>
                                </LoadScript>
                            </div>
                            {
                                jumpsinfos.length > 0 &&
                                <div className='tracks__body__track__jumps'>
                                    <div className='edittrack__body__track__jumps__title'>Jumps</div>
                                    <div className='tracks__body__track__jumps__jump'>
                                        <div className='tracks__body__track__jumps__jump__element'>#</div>
                                        <div className='tracks__body__track__jumps__jump__element'>dist.</div>
                                        <div className='tracks__body__track__jumps__jump__element'>key</div>
                                        <div className='tracks__body__track__jumps__jump__element'>text</div>
                                    </div>                                        
                                    {
                                        jumpsinfos.map((j: JumpInfos, i: number) => 
                                        {
                                            var selected = selectedpc && j.position && j.position.extra === selectedpc.extra;
                                            
                                            return (
                                                <div className={'tracks__body__track__jumps__jump' + (selected ? ' tracks__body__track__jumps__jump__active' : '')} key={'jump_' + i}>
                                                    <div className='tracks__body__track__jumps__jump__element tracks__body__track__jumps__jump__element__button' onClick={() => { changeselectedjump(j); }}>{j.number}</div>
                                                    <div className='tracks__body__track__jumps__jump__element'>{j.distance}</div>
                                                    <div className='tracks__body__track__jumps__jump__element'>{j.key}</div>
                                                    <Tooltip title={j.text} color="#888888"><div className='tracks__body__track__jumps__jump__element'>{j.text}</div></Tooltip>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>

                {
                    dlgcreatevenuevisible &&
                    <Modal className='tracks__modal' maskClosable={false} title={"Create venue"} open={dlgcreatevenuevisible} onOk={() => dlgcreatevenueclose(true)} onCancel={() => dlgcreatevenueclose(false)}>
                        <EditInfos type="small" label="code" value={editedvenue ? editedvenue.sic : ""} onChange={(v) => { if (editedvenue) editedvenue.sic = v as string}} />
                        <EditInfos type="string" label="name" value={editedvenue ? editedvenue.name : ""} onChange={(v) => { if (editedvenue) editedvenue.name = v as string}} />
                        <div className="tracks__editvalue">
                            <div className="tracks__editvalue__label">source</div>
                            <Select value={editedvenue ? editedvenue.source : ""} onChange={(v) => { if(editedvenue) editedvenue.source = v }} style={{ width: 150 }}>
                                {
                                    sources.map((v,i) => 
                                    {
                                        return (
                                            <Select.Option key={'source_' + i} value={v}>{v}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                    </Modal>
                }
                {
                    dlgeditvenuevisible &&
                    <Modal className='tracks__modal' maskClosable={false} title={"Edit venue"} open={dlgeditvenuevisible} onOk={() => dlgeditvenueclose(true)} onCancel={() => dlgeditvenueclose(false)}>
                        <Infos label="code" value={editedvenue?.sic} />
                        <EditInfos type="string" label="name" value={editedvenue?.name} onChange={(v) => { if (editedvenue) editedvenue.name = v as string}} />
                        <div className="tracks__editvalue">
                            <div className="tracks__editvalue__label">source</div>
                            <Select value={editedvenue ? editedvenue.source : ""} onChange={(v) => { if(editedvenue) editedvenue.source = v }} style={{ width: 150 }}>
                                {
                                    sources.map((v,i) => 
                                    {
                                        return (
                                            <Select.Option key={'source_' + i} value={v}>{v}</Select.Option>
                                        )
                                    })
                                }
                            </Select>
                        </div>
                    </Modal>
                }
                {
                    dlgaddtrackvisible &&
                    <Modal className='tracks__modal' maskClosable={false} title={"Add track"} open={dlgaddtrackvisible} onOk={() => dlgaddtrackclose(true)} onCancel={() => dlgaddtrackclose(false)}>
                        {
                            showfile &&
                            <EditInfos type="file" label="file" value='' onChange={(v) => { handleuploadfile(v as FileList); }} />
                        }
                        <div className="race__editvalue">
                            <div className="race__editvalue__label">venue</div>
                            <Select value={editedtrack.sic} onChange={(v) => { editedtrack.sic = v }} style={{ width: 100 }}>
                            {
                                venues.map((v,i) => 
                                {
                                    return (
                                        <Select.Option key={'venue_' + i} value={v.sic}>{v.sic}</Select.Option>
                                    )
                                })
                            }
                            </Select>
                        </div>
                        {
                            showinfos &&
                            <EditInfos type="small" label="code" value={editedtrack.code} onChange={(v) => { editedtrack.code = v as string}} />
                        }
                        {
                            showinfos &&
                            <EditInfos type="number" label="distance" value={editedtrack.distance} onChange={(v) => { editedtrack.distance = v as number}} />
                        }
                        <div className="race__editvalue">
                            <div className="race__editvalue__label">type</div>
                            <AutoComplete
                                value={editedtrack.type}
                                onChange={(v) => { editedtrack.type = v; setEditedTrack({...editedtrack}); }}
                                style={{ width: 100 }}
                                options={racetypes}
                            />
                        </div>
                    </Modal>
                }
                {
                    dlgtrackinfosvisible &&
                    <Modal className='tracks__modal' maskClosable={false} title={trackinfosmode === 'distance' ? "Edit official distance" : "Edit track type"} open={dlgtrackinfosvisible} onOk={() => dlgtrackinfosclose(true)} onCancel={() => dlgtrackinfosclose(false)}>
                        {
                            trackinfosmode === 'distance' &&
                            <EditInfos type="number" label="distance" value={trackinfosdistance} onChange={(v) => { setTrackInfosDistance(v as number); }} />
                        }
                        {
                            trackinfosmode === 'type' &&
                            <div className="race__editvalue">
                                <div className="race__editvalue__label">type</div>
                                <AutoComplete
                                    value={trackinfostype}
                                    onChange={(v) => { setTrackInfosType(v); }}
                                    style={{ width: 100 }}
                                    options={racetypes}
                                />
                            </div>
                        }
                    </Modal>
                }

            </div>
        </LayoutSite>
    );
}
